import { useNuxtApp } from '#app';
import { fireLinkTag } from '#shared/features/analytics/tagManager';
import { ASK_AI_HEADER_BTN_ENTRY_POINT, EVENT_SOURCE_PDP_PROMPT, FLOATING_ENTRY_POINT } from '#shared/constants/common/googleAgentEventNames';

let isInitialized = false;

/**
 * Composable for Ask AI analytics hooks.
 * This ensures that the hooks are set up only once
 */
export const useAskAIAnalytics = () => {
  const nuxtApp = useNuxtApp();
  if (isInitialized) {
    return;
  }
  isInitialized = true;

  nuxtApp.hook('ask-ai:google-agent-open-changed', (detail) => {
    if (!detail.isOpen) {
      return;
    }

    let source = detail?.source;
    // Fall back to window.pendingOpenAskAiPayload if the source was lost in a deferred GECX launch
    if (!source && window.pendingOpenAskAiPayload) {
      source = window.pendingOpenAskAiPayload?.source;
      window.pendingOpenAskAiPayload = undefined;
    }

    let eventName = '';
    if (source === ASK_AI_HEADER_BTN_ENTRY_POINT) {
      eventName = 'ask ai:open chat';
    } else if (source === FLOATING_ENTRY_POINT) {
      eventName = 'ask ai:open chat floating icon';
    }

    if (eventName) {
      fireLinkTag({
        event_name: eventName,
        link_name: eventName,
      });
    }
  });

  nuxtApp.hook('ask-ai:google-agent-user-input-entered', (detail) => {
    if (detail?.source === EVENT_SOURCE_PDP_PROMPT) {
      return;
    }
    fireLinkTag({
      event_name: 'ask ai:chat started',
      link_name: 'ask ai:chat started',
    });
  });

  nuxtApp.hook('ask-ai:google-agent-single-item-clicked', () => {
    fireLinkTag({
      event_name: 'ask ai:product click',
      link_name: 'ask ai:product click',
    });
  });
};
